import { HttpErrorResponse } from '@angular/common/http';

/** The readable sentence in a community API error ({"error": "..."}, {"detail": "..."}, {"field": ["..."]}). */
export function communityError(err: HttpErrorResponse, fallback: string): string {
  if (err?.status === 0) return "We can't reach the server right now. Check your connection and try again.";
  if (err?.status === 429) return "You're doing that too often. Wait a little and try again.";
  const body = err?.error;
  if (typeof body === 'string' && body.length < 300 && !body.trim().startsWith('<')) return body;
  if (body && typeof body === 'object') {
    for (const key of ['error', 'detail', 'message']) {
      if (typeof body[key] === 'string') return body[key];
    }
    for (const value of Object.values(body)) {
      if (Array.isArray(value) && typeof value[0] === 'string') return value[0];
    }
  }
  return fallback;
}

/** How the moderation log reads ("Mod banned Alice"). */
export const LOG_LABELS: Record<string, string> = {
  created: 'created the community',
  updated: 'updated the community details',
  deleted: 'deleted the community',
  approved_request: 'approved the request from',
  declined_request: 'declined the request from',
  removed: 'removed',
  banned: 'banned',
  unbanned: 'unbanned',
  made_moderator: 'made a moderator:',
  made_member: 'removed moderator role from',
  transferred: 'handed ownership to',
  created_link: 'created an invite link',
  revoked_link: 'turned off an invite link',
};
